import ReportYear from './ReportYear.vue';
import ReportRange from './ReportRange.vue';
export default {
    ReportYear,
    ReportRange,
}